import { render, staticRenderFns } from "./MypageBlockedUserItemSection.vue?vue&type=template&id=03c7b705&scoped=true"
import script from "./MypageBlockedUserItemSection.vue?vue&type=script&lang=js"
export * from "./MypageBlockedUserItemSection.vue?vue&type=script&lang=js"
import style0 from "./MypageBlockedUserItemSection.vue?vue&type=style&index=0&id=03c7b705&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c7b705",
  null
  
)

export default component.exports